import type { Currency } from '@backmarket/http-api/src/standards/Currency'
import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'

import createPriceFormatter from './createPriceFormatter'

export default function createCurrencySymbolFormatter(
  locale: Bcp47Locale,
  defaultCurrency: Currency,
) {
  return (currency = defaultCurrency, options = {}) =>
    createPriceFormatter(locale, currency)(
      { amount: '0.00', currency },
      options,
    )
      .replace(/[\d.,\s]/g, '')
      .trim()
}
